import { tableService } from '@services/domain-factories/tables/tables';
import { Table, TableForm, TableItem } from '@vincerosoft/assessfluence-types';
import { apiService } from 'src/backend-api/default.api';
import { accountStore } from 'src/stores/bootstrap-stores/account';

export type GetCollectionItemsOptions = {
  table?: Table;
  setTable?: (table: Table) => void;
  returnOnlyKeyAndValue?: boolean;
};

export async function getTableItems(form: TableForm, options?: GetCollectionItemsOptions) {
  const { setTable, returnOnlyKeyAndValue } = options || {};

  // 1. Resolve the table once. The form is only used to find it.
  const table = options?.table ?? (await tableService.getTable(form));
  if (!table) {
    return [] as TableItem[];
  }
  setTable?.(table);

  const requestOptions = returnOnlyKeyAndValue ? { select: ['external_id', 'label'] } : undefined;

  // 2. Table owner (tenant, group owner, or the entity of an ENTITY table): everything
  if (tableService.isOwnerOfScope(table)) {
    return apiService.getDocs<TableItem>(table.table_name, {}, requestOptions);
  }

  // 3. Anyone else is an eligible entity: items it created or that are shared with it
  const { scope, account } = accountStore.getState();
  if (['tenant', 'group'].includes(scope)) {
    return [];
  }

  return apiService.getDocs<TableItem>(
    table.table_name,
    { $or: [{ entity_id: account.id }, { shared_entity_ids: { $includes: account.id } }] },
    requestOptions
  );
}
